import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { styleBlock } from "../styleBlock";
export default class Stepper extends React.PureComponent {
    render() {
        const { step, steps, className } = this.props;
        const classNames = styleBlock("stepper");
        const cn = classNames({}).mix([className]);
        const stepsCount = Object.keys(steps).length;
        return (React.createElement("div", { className: cn.toString() },
            React.createElement(Row, { noGutters: true, className: "justify-content-center" }, steps.map((curstep, index) => {
                const isStepPassed = step > index + 1;
                const isStepActive = index + 1 === step;
                return (React.createElement(Col, { xs: "auto", key: `step-${curstep}`, className: "step" + (isStepPassed ? " step-passed" : "") + (isStepActive ? "  step-active" : "") },
                    React.createElement("span", { className: "step-circle" },
                        React.createElement("span", { className: "step-value" }, index + 1)),
                    React.createElement("span", { className: "step-total" },
                        "/",
                        stepsCount,
                        " \u2013\u00A0"),
                    React.createElement("span", { className: "step-name" }, curstep)));
            }))));
    }
}
//# sourceMappingURL=index.js.map